import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { ownerApi, OWNER_TOKEN, errText } from "@/lib/ownerApi";

export default function OwnerLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await ownerApi.post("/login", { email, password });
      localStorage.setItem(OWNER_TOKEN, data.access_token);
      nav("/entrepreneur", { replace: true });
    } catch (err) { toast.error(errText(err, "Login failed")); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-950 ptg-grid-bg p-4" data-testid="owner-login-page">
      <Seo title="Entrepreneur Login" />
      <div className="w-full max-w-md rounded-3xl bg-white p-8 sm:p-10 shadow-2xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-800 text-white"><Briefcase className="h-6 w-6" /></div>
          <div>
            <div className="font-heading text-xl font-extrabold text-slate-900">PTG Entrepreneur</div>
            <div className="text-xs font-semibold text-emerald-700 uppercase tracking-widest">Owner finance</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Lock className="h-5 w-5 text-emerald-800" /> Owner sign in</h1>
        <p className="text-sm text-slate-500 mt-1">Fees, salaries and profit. Private to the owner.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label htmlFor="owner-email" className="mb-1.5 block font-semibold text-slate-700">Email</Label>
            <Input id="owner-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="owner-login-email" required /></div>
          <div><Label htmlFor="owner-password" className="mb-1.5 block font-semibold text-slate-700">Password</Label>
            <Input id="owner-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="owner-login-password" required /></div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-emerald-800 hover:bg-emerald-900" data-testid="owner-login-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
